import { useCallback } from "react"
import { API_ENDPOINTS } from "../../../api/endpoints"
import { useApi } from "../../../hooks/useApi"
import { Auth0User } from "../../../interfaces/Auth0"

interface CreateUserResponse {
  user_id: string
}

export const useCreateUserAuth0 = () => {
  const api = useApi()

  return useCallback(
    async (newUser: Auth0User): Promise<string | null> => {
      const body = {
        username: newUser.username,
        email: newUser.email,
        password: newUser.password,
        blocked: newUser.blocked,
      }
      const response = await api.post<CreateUserResponse>(
        `${API_ENDPOINTS.BASE}auth0/users`,
        body,
        { errorMessage: "Error al crear el usuario en Auth0" },
      )
      return response?.user_id ?? null
    },
    [api],
  )
}
